const STORAGE_KEY = "indexaai_visitor_id";
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // 1 ano

function generateUuid(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  // Fallback pra contextos sem crypto.randomUUID (HTTP puro, browser antigo) —
  // formato v4-like, não é criptograficamente forte, mas serve só de agrupador
  // anônimo, não precisa ser imprevisível.
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === "x" ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

function readFromLocalStorage(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function writeToLocalStorage(id: string): boolean {
  try {
    localStorage.setItem(STORAGE_KEY, id);
    return true;
  } catch {
    return false;
  }
}

function readFromCookie(): string | null {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${STORAGE_KEY}=([^;]*)`));
    return match?.[1] ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

function writeToCookie(id: string): void {
  try {
    document.cookie = `${STORAGE_KEY}=${encodeURIComponent(id)}; max-age=${COOKIE_MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
  } catch {
    // storage indisponível (iframe sandboxed, config de privacidade) — segue sem persistir
  }
}

/**
 * Resolve um UUID anônimo persistente pro visitante atual: localStorage como
 * fonte primária, cookie first-party de 1 ano como fallback (ex: localStorage
 * desabilitado por config de privacidade). Idempotente — chamadas repetidas
 * (inclusive de múltiplas tags do script na mesma página) devem devolver o
 * mesmo id, nunca gerar um novo se já existe um persistido.
 */
export function getOrCreateVisitorId(): string | null {
  if (typeof document === "undefined") return null;

  const existing = readFromLocalStorage() ?? readFromCookie();
  if (existing) return existing;

  const id = generateUuid();

  if (!writeToLocalStorage(id)) {
    writeToCookie(id);
  }

  return id;
}
